import { Box, Typography } from "@mui/material";

import useColors from "../../api/hooks/useColors";

export default function TagInput({ tagStyle, color, size, children }) {
  const colors = useColors();

  const sizeMap = {
    S: {
      height: "20px",
      padding: tagStyle === "filled" ? "0 2px" : "0 8px",
      borderRadius: tagStyle === "rectangle" ? "4px" : "10px",
    },
    M: {
      height: "24px",
      padding: tagStyle === "filled" ? "0 2px" : "0 10px",
      borderRadius: tagStyle === "rectangle" ? "4px" : "12px",
    },
    L: {
      height: "32px",
      padding: tagStyle === "filled" ? "0 2px" : "0 12px",
      borderRadius: tagStyle === "rectangle" ? "4px" : "16px",
    },
  };

  const colorMap = {
    inherit: {
      text: colors.tag_input_inherit_text,
      bg: colors.tag_input_inherit_bg,
    },
    error: {
      text: colors.tag_input_error_text,
      bg: null,
    },
    success: {
      text: colors.tag_input_success_text,
      bg: null,
    },
    warning: {
      text: colors.tag_input_warning_text,
      bg: null,
    },
    overlay: {
      text: colors.tag_input_overlay_text,
      bg: colors.tag_input_overlay_bg,
    },
  };

  const border = ["outlined", "rectangle"].includes(tagStyle)
    ? `1px solid ${colors.tag_stroke}`
    : null;

  const sizeConfig = sizeMap[size];
  return (
    <Box
      display="flex"
      alignItems="center"
      width="fit-content"
      sx={{
        ...sizeConfig,
        border: border,
        backgroundColor: colorMap[color].bg,
      }}
    >
      <Typography
        variant={size === "L" ? "body2" : "caption"}
        sx={{
          whiteSpace: "nowrap",
          color: colorMap[color].text,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}
